import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { GoldDivider } from "@/components/GoldDivider";
import { useLang } from "@/i18n";

export const Legal = ({ kind }) => {
    const { t } = useLang();
    const doc = t(`legal.${kind}`);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [kind]);

    return (
        <main className="relative bg-ink min-h-screen px-5 sm:px-8 pt-32 pb-24" data-testid={`legal-${kind}-page`}>
            <div className="max-w-3xl mx-auto">
                <Reveal>
                    <h1 className="font-display font-semibold gold-text text-4xl sm:text-5xl tracking-wide text-center">
                        {doc.title}
                    </h1>
                    <p className="text-center text-xs text-sand font-light mt-3">{doc.updated}</p>
                    <GoldDivider className="my-10" />
                </Reveal>
                <div className="space-y-10">
                    {doc.sections.map((s, i) => (
                        <Reveal key={i} delay={i * 0.05}>
                            <section className="bg-surface border border-gold/15 rounded-sm p-7">
                                <h2 className="font-display text-xl font-semibold text-gold-soft tracking-wide mb-3">
                                    {s.h}
                                </h2>
                                <p className="text-sm text-cream/70 font-light leading-relaxed">{s.p}</p>
                            </section>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.15} className="text-center mt-12">
                    <a
                        href="/"
                        data-testid="legal-back-home-link"
                        className="inline-flex items-center gap-2 border border-gold/45 text-gold font-accent text-[10px] tracking-[0.22em] uppercase px-7 py-3 rounded-sm hover:bg-gold/10 transition-colors duration-300"
                    >
                        <ArrowLeft className="w-3.5 h-3.5" /> {t("footer.home")}
                    </a>
                </Reveal>
            </div>
        </main>
    );
};
